import React from 'react'
import { motion } from 'framer-motion'

interface SubServiceCardProps {
  title: string
  description: string
  icon: React.ReactNode
  delay?: number
}

export function SubServiceCard({
  title,
  description,
  icon,
  delay = 0,
}: SubServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="bg-white rounded-xl p-8 shadow-md border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
    >
      <div className="absolute top-0 left-0 w-1 h-full bg-primary transform origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-300" />
      <div className="flex flex-col sm:flex-row gap-6">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 rounded-lg bg-light-background flex items-center justify-center text-primary">
            {icon}
          </div>
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Poppins'] first-letter:uppercase">
            {title}
          </h3>
          <p className="text-gray-600 leading-relaxed font-['Roboto']">
            {description}
          </p>
        </div>
      </div>
    </motion.div>
  )
}